const FilePowerPoint = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.75 14.5H14.25C14.3875 14.5 14.5 14.3875 14.5 14.25V4.5H12.25C11.8365 4.5 11.5 4.1635 11.5 3.75V1.5H4.75C4.6125 1.5 4.5 1.6125 4.5 1.75V14.25C4.5 14.3875 4.6125 14.5 4.75 14.5Z"
      fill="#FFFFFF"
    />
    <path
      d="M14.1465 4.00002L12 1.85352V3.75002C12 3.88752 12.1125 4.00002 12.25 4.00002H14.1465Z"
      fill="#FFFFFF"
    />
    <path
      opacity="0.64"
      d="M14.78 3.927L12.073 1.2195C11.9321 1.07945 11.7417 1.00058 11.543 1H4.75C4.3365 1 4 1.3365 4 1.75V14.25C4 14.6635 4.3365 15 4.75 15H14.25C14.6635 15 15 14.6635 15 14.25V4.457C15 4.257 14.922 4.0685 14.78 3.927ZM12 1.8535L14.1465 4H12.25C12.1838 3.99987 12.1202 3.97349 12.0733 3.92663C12.0265 3.87978 12.0002 3.81627 12 3.75V1.8535ZM14.25 14.5H4.75C4.68373 14.4998 4.62022 14.4735 4.57337 14.4267C4.52651 14.3798 4.50013 14.3162 4.5 14.25V1.75C4.5 1.6125 4.6125 1.5 4.75 1.5H11.5V3.75C11.5 4.1635 11.8365 4.5 12.25 4.5H14.5V14.25C14.5 14.3875 14.3875 14.5 14.25 14.5Z"
      fill="#605E5C"
    />
    <path
      d="M10.5 9L10 8.5H9L8.5 9V10.4865C8.7308 10.8001 9.032 11.0552 9.3794 11.2312C9.72675 11.4073 10.1106 11.4993 10.5 11.5C10.8283 11.5 11.1534 11.4354 11.4567 11.3097C11.76 11.1841 12.0356 10.9999 12.2677 10.7677C12.4999 10.5356 12.6841 10.26 12.8097 9.9567C12.9354 9.6534 13 9.3283 13 9H10.5Z"
      fill="#ED6C47"
    />
    <path
      d="M8.5 7.5135V9H10.5V6.5C10.1106 6.50065 9.72675 6.5927 9.3794 6.76875C9.032 6.94475 8.7308 7.19985 8.5 7.5135Z"
      fill="#FF8F6B"
    />
    <path
      d="M11 6C11.663 6 12.2989 6.2634 12.7677 6.73225C13.2366 7.20105 13.5 7.83695 13.5 8.5H11V6Z"
      fill="#FFC7B5"
    />
    <path
      d="M1.75 12.5H7.25C7.4489 12.5 7.6397 12.421 7.78035 12.2803C7.921 12.1397 8 11.9489 8 11.75V6.25C8 6.0511 7.921 5.8603 7.78035 5.71965C7.6397 5.579 7.4489 5.5 7.25 5.5H1.75C1.55109 5.5 1.36032 5.579 1.21967 5.71965C1.07902 5.8603 1 6.0511 1 6.25V11.75C1 11.9489 1.07902 12.1397 1.21967 12.2803C1.36032 12.421 1.55109 12.5 1.75 12.5Z"
      fill="#C43E1C"
    />
    <path
      d="M4.76211 7.01001C5.2226 7.01001 5.5746 7.11701 5.8196 7.33001C6.0636 7.54351 6.1861 7.85251 6.1861 8.25701C6.1861 8.51701 6.1281 8.75001 6.0071 8.95201C5.8866 9.15451 5.7121 9.30901 5.4891 9.42101C5.2661 9.53351 5.0106 9.59201 4.71711 9.59201H3.98361L3.98111 11H3.39111V7.01001H4.76211ZM3.98111 9.00001H4.78861C5.0401 9.00001 5.2311 8.94101 5.3601 8.82351C5.4891 8.70551 5.5806 8.49601 5.5806 8.26951C5.5806 7.83001 5.3066 7.50001 4.81211 7.50001H3.98111V9.00001Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default FilePowerPoint;
